import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import cx from '../../../../utils/cx';

const CopyAddressWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 2rem;
    background-color: ${({ theme }) => theme.white};
    border-radius: 0.5rem;
    margin-top: 1rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text3};
    font-size: 0.8rem;
    font-weight: bold;
    text-align: center;
    position: relative;

    span {
        margin-right: 0.5rem;
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .copy-icon {
        color: ${({ theme }) => theme.text3};
    }

    @keyframes slide-in {
        0%   {top: 0rem;}
        25%  {top: -0.75rem;}
        50%  {top: -1.5rem;}
        100% {top: -2rem;}
    }

    .message {
        display: none;
        position: absolute;
        top: -2rem;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 0.8rem;
        color: ${({ theme }) => theme.white};
        background-color: ${({ theme }) => theme.green1};
        height: 1.5rem;
        line-height: 1.5rem;
        border-radius: 1rem;
        animation-name: slide-in;
        animation-duration: 0.2s;
        &.show {
            display: block;
        }
    }
`;

interface CopyAddressProps {
    address: string;
    text: string;
}

const CopyAddress = (props: CopyAddressProps) => {

    const [showMessage, setShowMessage] = React.useState(false);

    const handleClick = () => {
        navigator.clipboard.writeText(props.address);
        setShowMessage(true);
        setTimeout(() => {
            setShowMessage(false);
        }, 2000);
    }

    return (
        <CopyAddressWrapper onClick={handleClick}>
            <span>{props.text}</span>
            <div className={cx({ message: true, show: showMessage })}>Copied to Clipboard</div>
            <FontAwesomeIcon icon={faCopy} className={"copy-icon"} />
        </CopyAddressWrapper>
    )
}

export default CopyAddress;